"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _SenderGiftLanguage = _interopRequireDefault(require("../../containers/SenderGiftLanguage/SenderGiftLanguage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    draftIcon: {
      color: palette.green.main,
      marginRight: spacing(1)
    },
    section: {
      display: 'inline-block'
    },
    link: {
      marginLeft: 5
    }
  };
});

var FlowFooter = function FlowFooter(_ref2) {
  var giftUpdatedAt = _ref2.giftUpdatedAt,
      discardGiftHandler = _ref2.discardGiftHandler;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.section)
  }, "Don\u2019t want to send this ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null), "?"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    onClick: discardGiftHandler,
    className: (0, _classnames.default)('Body-Small-Error Text-Pointer', classes.section, classes.link)
  }, "Discard ", /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, null))), giftUpdatedAt && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    icon: "save",
    className: (0, _classnames.default)(classes.section, classes.draftIcon)
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Small-Inactive', classes.section)
  }, /*#__PURE__*/_react.default.createElement(_SenderGiftLanguage.default, {
    className: "Text-Capitalize"
  }), " progress saved @ ", giftUpdatedAt)));
};

FlowFooter.propTypes = {
  giftUpdatedAt: _propTypes.default.string,
  discardGiftHandler: _propTypes.default.func.isRequired
};
FlowFooter.defaultProps = {
  giftUpdatedAt: ''
};
var _default = FlowFooter;
exports.default = _default;